import { AppBar, Grid, Tab } from '@mui/material'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
    ResultTablesTabs, FormTitleTypography,
    FormHeaderPaper, FormDescriptionTypography,
} from '../../../components/CustomStyles/StyledComponents'
import DataChecksErrors from '../../../components/Errors/DataChecksErrors';
import { ResultStatus } from '../../../helpers/reportResultsHelper';
import {
    getEnterpriseCompareToList, getWholeFarmDetailedTable, getFarmReport, getAllReports,
    setLoading, setReportId, unsetLoading, getUserPermissionsForFarm
} from '../../../store/appAction';
import { WHOLE_FARM_DETAILED_TABLES, SUMMARY_TABLE } from '../../../constants/shellTables';
import SelectedFarm from '../../../components/SelectedFarm/SelectedFarm';
import ResultsReportsBar from '../../../components/Results/ResultsReportsBar';
import DataTable from '../../../components/Results/ResultsDataTable';


const WholeFarmTables = () => {
    const dispatch = useDispatch();
    const detailedResults = useSelector(state => state.wholeFarm.tableDetailedResults);
    const reportId = useSelector(state => state.common.reportId);
    const reportSettings = useSelector(state => state.farmReport.reportSettings);
    const reportList = useSelector(state => state.farm.reports);
    const farmId = useSelector(state => state.adminFarm.farmId);
    const permissions = useSelector(state => state.auth.farmPermissions); //user permissions in relation to the farm
    const [currentTab, setCurrentTab] = useState(0);

    const reloadData = () => {
        dispatch(setLoading());
        dispatch(getFarmReport({ reportId })); //reportSettings
        dispatch(getWholeFarmDetailedTable({ reportId })); //detailedResults
        dispatch(getEnterpriseCompareToList({ reportId }));
    }
    useEffect(() => {
        dispatch(setLoading());
        dispatch(getAllReports({ farmId }));
        dispatch(getUserPermissionsForFarm({ farmId }));
    }, [dispatch, farmId]);

    useEffect(() => {
        reloadData();
    }, [reportId, dispatch]);


    useEffect(() => {
        dispatch(unsetLoading());
    }, [reportSettings, dispatch]);

    const handleTabChange = (event, tab) => {
        setCurrentTab(tab);
    };

    const handleReportSelect = (e) => {
        dispatch(setReportId(e.target.value));
    }

    let shellTables = currentTab === 0 ? SUMMARY_TABLE : WHOLE_FARM_DETAILED_TABLES
    let calcStatus = reportSettings ? reportSettings.calculationStatus : ResultStatus.NotCalculated

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={12} lg={12}>
                <FormHeaderPaper
                    sx={{
                        p: 0,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <SelectedFarm />
                    <FormTitleTypography variant="h5" component="div">
                        Resource use & Emissions Results
                    </FormTitleTypography>
                    <FormDescriptionTypography variant="body2" paragraph>
                        {`A ${currentTab === 0 ? 'summary' : 'detailed view'} of emissions from carbon dioxide, methane and nitrous oxide for the whole farm and per enterprise is presented below.`}
                    </FormDescriptionTypography>
                    <FormDescriptionTypography variant="body2" paragraph>
                        {currentTab === 0 ?
                            'To view where the emissions came from select the Detailed tab below.' :
                            'For a higher level view of emissions please select the Summary tab below.'}
                        {' To view this information at a higher level please select Whole Farm - Charts in the menu above.'}
                    </FormDescriptionTypography>
                </FormHeaderPaper>
            </Grid>
            <Grid item xs={12}>
                <AppBar position="static">
                    <ResultTablesTabs
                        value={currentTab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        variant="standard"
                        aria-label="full width tabs example"
                        autoFocus={true}
                    >
                        <Tab sx={{ textTransform: 'none' }} label="Summary" autoFocus={true} disabled={calcStatus !== ResultStatus.Completed} />
                        <Tab sx={{ textTransform: 'none' }} label="Detailed" disabled={calcStatus !== ResultStatus.Completed} />
                    </ResultTablesTabs>
                </AppBar>
            </Grid>
            <Grid item xs={12} mb={0} mt={2}>
                <ResultsReportsBar handleReportSelect={handleReportSelect}
                                   reportList={reportList}
                                   reportId={reportId}
                                   calcStatus={calcStatus}
                                   permissions={permissions}
                                   onRecalculated={reloadData}/>
            </Grid>
            {calcStatus !== ResultStatus.Completed ?
                <DataChecksErrors errorList={detailedResults?.dataChecks} resultStatus={calcStatus} /> :

                <Grid item xs={12} md={12} lg={12} sx={{ minHeight: 300 }}>
                    {Object.entries(shellTables).map(([tableKey, tableData]) => (
                        <DataTable
                            key={tableKey}
                            tableId={tableKey}
                            tableData={tableData}
                            resultsData={detailedResults[tableKey]}
                            media='screen'
                        />
                    ))}
                </Grid>
            }
        </Grid >
    )
}

export default WholeFarmTables